import {Stack, Typography} from "@mui/material";
import TrueIcon from '@mui/icons-material/Done';
import FalseIcon from '@mui/icons-material/Close';


interface BooleanFieldProps {
    title: string;
    value: boolean | undefined;
}
export default function BooleanField({value = false, title = "Missing field text"} : BooleanFieldProps) {
    return (
        <Stack direction="row" spacing={1}>
            {value === true ? <TrueIcon sx={{color: '#247824'}}/> : <FalseIcon sx={{color: '#a51111'}}/>}
            <Typography>{title}</Typography>
        </Stack>
    );
}